import { Link } from 'react-router-dom';
import { useScrollReveal, useScrollRevealGroup } from '@/hooks/useScrollReveal';

const values = [
  {
    icon: 'ri-timer-flash-line',
    title: 'Быстрее конкурентов',
    desc: 'Система начинает диалог в первые 60 секунд после появления запроса. Пока конкуренты собирают заявки — вы уже общаетесь с клиентом.',
    stat: '< 60 сек',
  },
  {
    icon: 'ri-fire-line',
    title: 'Только горячий спрос',
    desc: '98% точность определения коммерческого намерения. Вы получаете не холодные контакты, а людей, которые прямо сейчас ищут решение.',
    stat: '98%',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Прогнозируемый результат',
    desc: 'Каждый лид проходит квалификацию перед передачей. Менеджер получает готовую сделку, а не заявку на обработку.',
    stat: '×3.5',
  },
];

export default function ValueSection() {
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 150 });
  const { containerRef: cardsRef, revealedCount: cardsRevealed } = useScrollRevealGroup<HTMLDivElement>(3);
  const { ref: btnsRef, revealed: btnsRevealed } = useScrollReveal({ delay: 300 });

  return (
    <section className="relative py-20 md:py-28 bg-background-100">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-primary-500/5 pointer-events-none"></div>
      <div className="relative max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-12 md:mb-16">
          <span
            ref={labelRef}
            className={`inline-flex items-center gap-2 text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}
          >
            <span className="w-2 h-2 rounded-full bg-primary-500"></span>
            Почему AIGAM
          </span>
          <h2
            ref={titleRef}
            className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}
          >
            Вы получаете клиентов, которые уже ищут решение. Без холодного трафика, без долгих циклов.
          </h2>
        </div>

        <div ref={cardsRef} className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 mb-12">
          {values.map((item, idx) => (
            <div
              key={item.title}
              className={`group rounded-2xl border border-background-200 bg-background-50 hover:border-foreground-950 transition-all duration-300 p-7 flex flex-col reveal-fade-up ${idx < cardsRevealed ? 'revealed' : ''}`}
              style={idx < cardsRevealed ? { transitionDelay: `${idx * 100}ms` } : undefined}
            >
              <span className="w-12 h-12 rounded-xl bg-primary-50 text-primary-500 flex items-center justify-center mb-6">
                <i className={`${item.icon} text-[22px]`}></i>
              </span>
              <div className="font-display text-[32px] font-extrabold text-foreground-950 mb-1">{item.stat}</div>
              <h3 className="font-display font-bold text-[17px] text-foreground-950 mb-2">
                {item.title}
              </h3>
              <p className="text-[14.5px] text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div
          ref={btnsRef}
          className={`flex flex-col sm:flex-row items-start sm:items-center gap-3 reveal-fade-up ${btnsRevealed ? 'revealed' : ''}`}
        >
          <Link
            to="/telegram-leads"
            className="h-12 px-7 inline-flex items-center justify-center rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-[15px] font-semibold transition-colors cursor-pointer whitespace-nowrap"
          >
            Запустить систему
            <i className="ri-arrow-right-line ml-2 text-lg"></i>
          </Link>
          <a
            href="#demo-form"
            className="h-12 px-6 inline-flex items-center justify-center rounded-md border border-background-200 hover:border-background-300 hover:bg-background-100 text-foreground-700 text-[15px] font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            Получить демо
          </a>
        </div>
      </div>
    </section>
  );
}